// Cookies reales del configurador (dominio ingeteam.com), agrupadas por categoría.
// "key" enlaza con las traducciones cookiesPurpose.<key> y cookiesRetention.<key>.
// "names" y "provider" son constantes (no se traducen).
export const COOKIES_GROUPS = [
  {
    category: "necessary",
    cookies: [
      { key: "session", names: "cookiesession1", provider: "Ingeteam" },
      { key: "consent", names: "CookieConsent", provider: "Cookiebot" },
    ],
  },
  {
    category: "statistics",
    cookies: [
      { key: "ga", names: "_ga, _ga_*", provider: "Google Analytics" },
      { key: "clarity", names: "_clck, _clsk", provider: "Microsoft Clarity" },
      {
        key: "hubspot",
        names: "__hstc, __hssc, __hssrc, hubspotutk",
        provider: "HubSpot",
      },
    ],
  },
  {
    category: "marketing",
    cookies: [
      { key: "googleads", names: "_gcl_au", provider: "Google Ads" },
      {
        key: "bing",
        names: "_uetsid, _uetvid, MUID",
        provider: "Microsoft Advertising",
      },
      { key: "leadfeeder", names: "_lfa", provider: "Leadfeeder" },
    ],
  },
]
